





















































































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({})
export default class detail extends Vue {
  @Prop({ type: String, required: true }) name: any
  get isCn(): boolean {
    return this.$store.getters.i18nLocale === 'us' ? false : true
  }
  speeker2: String = `<h2>Education</h2><p class="content speeker2">1975 – 1980: Wimbledon College</p><p class="content speeker2">1981 – 1986: University of Cambridge</p><p class="content speeker2" style="display:flex;white-space: nowrap;">1994 – 1996: Harkness Fellow, City & Regional Development, Columbia University in the City of New York</p><p class="content speeker2">1997 – 1999: Research Scholar, the London School of Economics and Political Science (LSE)</p><h2>Professional career</h2><p class="content speeker2">1996 – 2016</p><p class="content speeker2">Chairman, Forum of Cities and Regions, OECD - OCDE</p><p class="content speeker2">2004 – 2010</p><p class="content speeker2">Lead Advisor City & Regional Development, Office of the Deputy Prime Minister of the UK</p><p class="content speeker2">2007 - Present</p><p class="content speeker2">Senior Fellow, Urban Land Institute Europe, Urban Land Institute</p><p class="content speeker2">2010 – 2014</p><p class="content speeker2">Global Advisor, Urbanisation Knowledge Platform, World Bank Group</p><p class="content speeker2">2010– Present</p><p class="content speeker2">Chairman, the Business of Cities Ltd.</p><p class="content speeker2">2011 – Present</p><p class="content speeker2">Global Fellow, the Brookings Institution</p><p class="content speeker2">2014 – Present</p><p class="content speeker2">Chairman, Cities Research Centre, JLL</p><p class="content speeker2">2014 - Present</p><p class="content speeker2">Hon Professor, City Leadership Lab, UCL</p><p class="content speeker2">2016 – Present</p><p class="content speeker2">Global Fellow, LSE Cities</p><p class="content speeker2">2016 – Present</p><p class="content speeker2">Board of Directors and Chairman of Investment and Programmes Committee, Transport for London</p><p class="content speeker2">2018 – Present</p><p class="content speeker2">Senior Advisor & Vice Chairman, Future Cities & New Industries, HSBC Global Banking and Markets</p>`
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 0
  }
}
